import React from "react";
import { Step, Stepper as MuiStepper, StepLabel } from "@mui/material";

const useStepper = (steps = []) => {
  // stepper state and function
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const allStepsCompleted = () => {
    return activeStep + 1 === steps.length;
  };

  const Stepper = ({ orientation = "horizontal" }) => {
    return (
      <MuiStepper nonLinear activeStep={activeStep} orientation={orientation}>
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};

          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </MuiStepper>
    );
  };

  return {
    activeStep,
    Stepper,
    handleNext,
    handleBack,
    allStepsCompleted,
  };
};

export default useStepper;
